import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Componente1Component } from './componente1.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    Componente1Component

  ]
  , exports: [
    Componente1Component
  ]
})
export class Componente1Module { }
